import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { alpha, useTheme as useMuiTheme } from "@mui/material/styles";
import {
  DarkModeOutlined as DarkModeIcon,
  LightModeOutlined as LightModeIcon,
} from "@mui/icons-material";
import { useTheme } from "@contexts/ThemeContext";

// Alternador claro/escuro. É um botão de dois estados: o nome acessível é fixo
// ("Tema escuro") e o estado vai em `aria-pressed`. Mudar o nome junto com
// `aria-pressed` faria o leitor de tela anunciar o estado ao contrário.
const ThemeModeToggle = ({ sx }) => {
  const { isCurrentThemeDark, toggleDarkMode } = useTheme();
  const muiTheme = useMuiTheme();
  const escuro = isCurrentThemeDark();

  return (
    <Tooltip title={escuro ? "Ativar tema claro" : "Ativar tema escuro"}>
      <IconButton
        color="inherit"
        onClick={toggleDarkMode}
        aria-label="Tema escuro"
        aria-pressed={escuro}
        sx={{
          backgroundColor: alpha(muiTheme.palette.common.white, 0.12),
          border: `1px solid ${alpha(muiTheme.palette.common.white, 0.18)}`,
          transition: "transform 0.2s ease, background-color 0.2s ease",
          "&:hover": {
            backgroundColor: alpha(muiTheme.palette.common.white, 0.2),
            transform: "translateY(-1px)",
          },
          ...sx,
        }}
      >
        {escuro ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
